import React from 'react'

function NoDataFound() {
    return <div className='flex flex-row justify-center text-sm'>No data found</div>
}

export default NoDataFound
